export default {
      id: "planner-options-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-options",
      toString: function () {
        return this.url;
      }
    }